
export default class LocalAutocompleteManager {
    options:any[] = []

    _list(config?: any) {
        return Promise.resolve({data: this.options});
    }

    _retrieve(id: number | string) {
        return Promise.resolve({
            data: this.options.find((el) => {
                return el.id == id
            })
        });
    }

    setOptions(new_opts: any[]) {
        this.options.splice(0, this.options.length, ...new_opts)
    }

    list = this._list
    retrieve = this._retrieve
}

